module.exports = __webpack_public_path__ + "media/property_transaction_process/house_en-1dbf5e2d.svg";